export const environment = {
  production: false,
  version: '1.0.0-#65',
  apiBaseUrl: 'https://apis.dev.auckland.ac.nz/nzseis/stations/v1',
  imagesBaseUrl: '', // e.g. https://nzseis-stations-images-dev.s3.ap-southeast-2.amazonaws.com
  linzApiKey: 'd01eyvkkr9erajj4zpeqykezbgn', // From legacy PHP app
  auth: {
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoClientId: '1hk5a6vduu17h0eebit1kv9445', // Your consumer's client ID from Athena: /<env>/<project>/<project>-ACF-id
    cognitoUserPoolId: 'ap-southeast-2_gtuqqgIIq',
    cognitoDomain: 'uoapool-nonprod',
    redirectUri: 'https://nzseis-stations.dev.auckland.ac.nz', // CloudFront / S3 website URL for this env; register in Athena
    logoutUri: 'https://www.auckland.ac.nz/en/about-us/about-the-university/identity-and-access-management/single-sign-on/verify-logout.html',
    scopes: 'openid profile https://auth2.auckland.ac.nz/api-nzseis-stations-v1:read https://auth2.auckland.ac.nz/api-nzseis-stations-v1:write', //Scopes which will be included in your access token. Should always include openid & profile + any other API specific scopes required.
    codeChallengeMethod: 'S256',
  },
  privateUrlKeyWords: {
    whoNeedBearerToken: [{ url: 'apis.dev.auckland.ac.nz', optional: true, protectedPaths: ['admin'] }],
  },
};
